module.exports = __webpack_public_path__ + "static/img/torsoScaled1.aec37543.jpg";